import { requestGet as wsRequestGet, requestPost as wsRequestPost } from './_wsApiFetchData';

export async function searchFacilityTexts({ filters }, language, timeZone, cancelToken) {
  const cleanFilters = filters ? Object.keys(filters).reduce((acc, key) => {
    const value = filters[key];
    if (key && value !== undefined && value !== 'undefined' && value !== '') {
      acc[key] = value;
    }
    return acc;
  }, {}) : {};

  return await wsRequestGet('/admin/facilitycontent', language, timeZone, Object.keys(cleanFilters).length > 0 ? cleanFilters : null, cancelToken);
}

export async function getFacilityText(id, language, timeZone, cancelToken) {
  return await wsRequestGet('/admin/facilitycontent/get-by-id', language, timeZone, { id }, cancelToken);
}

export async function saveFacilityText(data, language, timeZone, cancelToken) {
  return await wsRequestPost('/admin/facilitycontent/save', language, timeZone, data, null, cancelToken);
}

export async function deleteFacilityText({ facilityId, contentLanguage }, language, timeZone, cancelToken) {
  return await wsRequestPost(
    '/admin/facilitycontent/delete',
    language,
    timeZone,
    null,
    { facilityId, language: contentLanguage },
    cancelToken
  );
}
